import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JobLeftComponent } from './job-left.component';
import { ExternalNotesModule } from '../external-notes/external-notes.module';
import { FormsModule } from '@angular/forms';
import { AiAssistantModule } from '../ai-assistant/ai-assistant.module';
import { SkeletonLoaderModule } from '../skeleton-loader/skeleton-loader.module';

@NgModule({
  declarations: [JobLeftComponent],
  imports: [
    CommonModule,
    FormsModule,
    ExternalNotesModule,
    AiAssistantModule,
    SkeletonLoaderModule
  ],
  entryComponents: [JobLeftComponent],
  exports: [JobLeftComponent]
})
export class JobLeftModule { }
